import { render } from "./BusinessRuleActionViewModal.vue?vue&type=template&id=3e25de40"
import script from "./BusinessRuleActionViewModal.vue?vue&type=script&lang=js"
export * from "./BusinessRuleActionViewModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__